export enum ConnectionStatus {
    Online = 'Online',
    Offline = 'Offline'
}
